export const STATISTICS_PERIODS = {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

export const DEFAULT_STATISTICS_PERIOD = STATISTICS_PERIODS.MONTHLY;
